export enum NavAnalyticsType {
  Header = 'header',
  Nav = 'nav',
  NavTray = 'navtray',
  Breadcrumb = 'breadcrumb',
  Search = 'search'
}

export type NavAnalyticsClickHandler = (
  e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>
) => void
